module.exports = __webpack_public_path__ + "static/media/5DPO11.e144fa7f.jpg";